import React, { useState } from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import SlidingPane from 'react-sliding-pane'

export const SearchOptionItems = ({ columns, onFilter, title }) => {
  const [isPaneOpen, setIsPaneOpen] = useState(false)
  return (
    <>
      <ReactBootstrap.Button
        variant="dark"
        size="sm"
        onClick={() => setIsPaneOpen(true)}
      >
        {components.ICONS.SEARCH}
      </ReactBootstrap.Button>
      <SlidingPane
        overlayClassName="on-top"
        sliderWidth={"20vw"}
        isOpen={isPaneOpen}
        title={title}
        onRequestClose={() => {
          setIsPaneOpen(false)
        }}
      >
        <components.GenericSearchForm columns={columns} onFilter={onFilter} />
      </SlidingPane>
    </>
  )
}
